import { NotificationsCategory } from "../../../components/nav-bar/Models/notification.model";

export class UserPreference {}

export class ShowEditableNotificationCategories {
    category: NotificationsCategory;
    isSelected: boolean;
}

export class UserProfile {
    userId: number;
    primaryEmail: string;
    isPrimaryEmailPersonal: boolean;
    alternateEmail?: string | null;
    isAlternateEmailPersonal?: boolean | null;
    personalEmail?: string | null;
    currentOrgEmail: string;
    firstName: string;
    lastName: string;
    middleName?: string | null;
    givenName: string;
    locale?: string | null;
    city: string;
    highestEducation: number;
    secondHighestEducation?: number | null;
    gender: number;
    ageRange: number;
    timeZone: string;
    countryId: number;
    countryName: string;
    createdDateTime: string;
    lastUpdatedDateTime: string;
    imageData: string;

    constructor(init?: Partial<UserProfile>) {
        Object.assign(this, init);
    }

    get fullNameOfUser() {
        let fullName = this.firstName;

        if (this.middleName) {
            fullName += ` ${this.middleName}`;
        }

        fullName += ` ${this.lastName}`;

        return fullName.trim(); // Trim to remove any leading or trailing spaces
    }
}

export const UserProfileFormControlNames = {
    GIVEN_NAME: "givenName",
    CITY: "city",
    COUNTRY: "country",
    EDUCATION: "education",
    GENDER: "gender",
    AGE_RANGE: "ageRange",
    IMAGE_DATA: "imageData",
};

export class UserProfileFormRequestBody {
    constructor(
        public userId: number,
        public timeZone: string,
        public givenName: string,
        public gender: number,
        public ageRange: number,
        public city: string,
        public countryId: number,
        public highestEducation: number,
        public imageData: string,
    ) {}
}

// imageData
export class UserDefaultImage {
    imageData: string;
}




